import React from "react";
import { useHistory } from "react-router";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Gap from "../../../components/Gap";
import useStyles from "./style";

function EmptyOrder() {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={classes.emptyCart}>
      <Typography className={classes.emptyCartTitle}>
        Belum Ada Pesanan
      </Typography>
      <Typography>
        Setelah belanja di aplikasi, kamu bisa pantau transaksimu di sini
      </Typography>
      <Gap height={16} />
      <Button
        variant="outlined"
        color="primary"
        onClick={() => history.push("/")}
        style={{ textTransform: "capitalize" }}
      >
        Belanja Sekarang
      </Button>
    </div>
  );
}

export default EmptyOrder;
